import { httpClient } from "src/shared/services/httpClient";
import { AxiosPromise } from "axios";
import { OAuthModes } from "src/welcome/types";

export const getOauthHandleForRegistration = (
  token: string,
  oauthVerifier: string,
) => {
  return httpClient.get(
    `welcome/oauthHandle?oauth_token=${token}&oauth_verifier=${oauthVerifier}`,
  );
};

export const getRegistrationFormInfo = (bid: number) =>
  httpClient.get(`welcome/registrationForm?bid=${bid}`);

export const registerUser = (data: Object) => {
  const formData = new FormData();

  for (const key in data) {
    formData.append(key, data[key]);
  }

  return httpClient.post("welcome/registration", formData);
};

export const reminderUser = (data: {
  username: string;
  email: string;
  accountType: string;
}) => {
  const formData = new FormData();

  formData.append("username", data.username);
  formData.append("email", data.email);
  formData.append("userType", data.accountType);

  return httpClient.post("welcome/reminder", formData);
};

export const getOauthHandleForReminder = (
  mode: string,
  token: string,
  oauth_verifier: string,
) => {
  return httpClient.get(
    `welcome/oauthHandleForReminder?mode=${mode}&oauth_token=${token}&oauth_verifier=${oauth_verifier}`,
  );
};

export const resetPassword = (data: {
  newPassword: string;
  confirmPassword: string;
}) => {
  const formData = new FormData();

  formData.append("m01_password1", data.newPassword);
  formData.append("m01_password2", data.confirmPassword);

  return httpClient.post("welcome/resetPasswordAndLogin", formData);
};

export const ggpsNew = ({
  mode,
}: {
  mode: string;
}): AxiosPromise<{ url: string }> =>
  httpClient.get("welcome/ggpsNew?mode=" + mode);

export const oauthHandleNew = (
  mode: string | null,
  code: string | null,
  state: string | null,
  errorDescription: string | null,
): AxiosPromise<{ url: string }> =>
  httpClient.get(
    `welcome/oauthHandleNew?mode=${mode ?? ""}&code=${code ?? ""}&state=${state ?? ""}&error_description=${errorDescription ?? ""}`,
  );

export const processOAuthSuccess = (): AxiosPromise<{
  mode: OAuthModes;
  navigateUrl: string;
  m01Id?: string;
  m01UserName?: string;
  bid?: string;
  afm?: string;
  message?: string;
  nameTitlePurchaseAppId?: string;
}> => httpClient.get(`welcome/processOAuthSuccess`);
